export default "__VITE_ASSET__BakGu5Os__"